export default "__VITE_ASSET__DLrjlRxJ__"